module.exports = __webpack_public_path__ + "img/glasses.19a9908e.png";